import { ProductPayment } from '../types/transactionTypes';
import IcClockFilledPrimary from '@/assets/icons/ic-clock-filled-primary.svg';
import IcCheckCircleFilled from '@/assets/icons/ic-check-circle-filled-positive.svg';
import IcWarningCircleFilled from '@/assets/icons/ic-warning-circle-filled-negative.svg';
import { formatEventData } from '../income.logic';

export function TransactionTimelineDetails({ paymentData }: { paymentData: ProductPayment }) {
    const stripeEvents = paymentData.stripe_events;
    return (
        <div className='before:border-neutral-subtle relative -mt-3 before:absolute before:top-6 before:left-[11px] before:z-0 before:flex before:h-[calc(100%-57px)] before:items-center before:justify-center before:border before:leading-8 before:content-[""]'>
            {stripeEvents.map(stripeEvent => {
                const eventData = formatEventData(stripeEvent, paymentData);
                const icon = eventData.icon;
                return (
                    <div className='relative z-10 flex py-3' key={stripeEvent.event_id}>
                        <div className='mr-3 flex aspect-square size-6 items-center justify-center rounded-4xl'>
                            {icon === 'waiting' && <IcClockFilledPrimary v-if=" === 'waiting'" className='img' />}
                            {icon === 'success' && <IcCheckCircleFilled className='img' />}
                            {icon === 'failure' && <IcWarningCircleFilled className='img' />}
                        </div>
                        <div className=''>
                            <div
                                className='text-dark mb-1 text-sm'
                                dangerouslySetInnerHTML={{ __html: eventData.title }}
                            />
                            <div className='text-gray text-xs'>
                                {formatEventData(stripeEvent, paymentData).subtitle}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
